import { useQuery } from '@tanstack/react-query';

export const queryKey = 'create-task-shortcut';

export const useCreateTaskShortcutQuery = () =>
  useQuery({
    queryKey: [queryKey],
    queryFn: () => window.electron?.getCreateTaskPopoverShortcut?.() ?? null,
  });
